import {FaAward} from 'react-icons/fa'
import {TbBooks} from 'react-icons/tb'
import {BiHappyHeartEyes} from 'react-icons/bi'

const data = [
    {id:1, icon: <FaAward/>, title: 'Experience', desc:'3+ Years Academic and Personal'},
    {id:2, icon: <TbBooks/>, title: 'Projects', desc:'2 Academic, 1 Personal'},
    {id:3, icon: <BiHappyHeartEyes/>, title:'Languages', desc:'C++, Python, Javascript, HTML, CSS'}
]

export default data 